import React from 'react'

import { FixedImage } from 'components/NextImage'

import classes from './Logo.module.scss'

// Default value for most pages render width
export const PRODUCT_CARD_WIDTH = 100

/** @type {import("./types").default} */
const Logo = ({ className, src, alt, size, fetchWidth = PRODUCT_CARD_WIDTH, loading }) => (
  <div className={className} style={{ height: size, width: size }}>
    <FixedImage alt={alt} className={classes.logo} src={src} fetchWidth={fetchWidth} loading={loading} />
  </div>
)

export default Logo
